export default {
    custom_zh: '黑箱定制英文'
};
